export default __webpack_public_path__ + "static/media/1.f3d5f3f2.jpg";